var React = require('react');

function Ground (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"40.5","height":"283.5","className":"a","key":0}),React.createElement("rect",{"x":"81","width":"40.5","height":"283.5","className":"a","key":1}),React.createElement("rect",{"x":"162","width":"40.5","height":"283.5","className":"a","key":2}),React.createElement("rect",{"x":"243","width":"40.5","height":"283.5","className":"a","key":3})]);
}

Ground.defaultProps = {"fill":"#d57363","width":"283","height":"283","viewBox":"0 0 283.5 283.5"};

module.exports = Ground;

Ground.default = Ground;
